import { DataBean } from "../DataBean";

export class IncomeAdjustment extends DataBean {


    public async createDocumentIncomeAdjustment(idIncomeDocument: number, documentDate: any, accountantDate: any, idAccount: number, idBusinessCore: number, idProject: number, description: string, idEmployee: number, createPdf: boolean): Promise<any> {
        return this.getCustomService("QuickDataERPCore",
            "com.quickdataerp.bean.accountant.AccountantDocument_createDocumentIncomeAdjustment_Number_java.util.Date_java.util.Date_Number_Number_Number_String_Number_Boolean",
            [idIncomeDocument, documentDate, accountantDate, idAccount, idBusinessCore, idProject, description, idEmployee, createPdf]);
    }

}